
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/metal-resources/tools-calculators",
      function () {
        return require("private-next-pages/metal-resources/tools-calculators/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/metal-resources/tools-calculators"])
      });
    }
  